import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
    },
    labelMore: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
    },
    showMoreLessButton: {
      whiteSpace: 'nowrap',
      display: 'flex',
      maxWidth: 'unset !important',
      fontWeight: theme.typography.fontWeightMedium,
    },
    showMoreChip: {},
    icon: {
      fontSize: theme.typography.pxToRem(12),
      fontWeight: theme.typography.fontWeightRegular,
    },
  }),
  { name: 'TagsPositioner' }
);
